import React from 'react';
import cn from 'classnames';
import { TextField, OutlinedTextFieldProps } from '@material-ui/core';
import { QaType } from 'models';
import { makeStyles } from '@material-ui/core/styles';

export interface CusomTextFieldProps extends Partial<OutlinedTextFieldProps> {
	qaType?: QaType;
	variant?: OutlinedTextFieldProps['variant'];
}

const useStyles = makeStyles({
	selectInput: {
		'& input': {
			boxSizing: 'border-box',
		},
	},
});

export const CusomTextField = React.forwardRef<HTMLDivElement, CusomTextFieldProps>(
	(
		{
			id,
			name,
			margin = 'normal',
			qaType = 'text',
			type = 'text',
			className,
			autoComplete = 'off',
			select,
			label,
			...props
		},
		ref
	) => {
		const classes = useStyles();

		return (
			<TextField
				{...props}
				inputRef={ref}
				variant="outlined"
				name={name}
				id={id || name}
				className={cn(className, {
					[classes.selectInput]: select,
				})}
				select={select}
				margin={margin}
				type={type}
				fullWidth
				title={(typeof label === 'string' && label) || ''}
				label={label}
				autoComplete={autoComplete}
				inputProps={{
					'qa-id': `input-${name}`,
					'qa-data': `input-${name}`,
					'qa-type': qaType,
					min: 1,
				}}
			/>
		);
	}
);
